import React from 'react';
import { Modal, Checkbox, Tooltip, Button, message } from 'antd';
import { network, generators } from '../../../utils';
import api from '../../../config/api';
import './index.less';

const { generatorObject } = generators;

export default ({ list, onCancel, onConfirm }) => {
  const [visible, setVisible] = React.useState(false);
  const [value, setValue] = React.useState([]);
  const [confirmLoading, setConfirmLoading] = React.useState(false);

  React.useEffect(() => {
    setVisible(true);
  }, []);

  React.useEffect(() => {
    let ids = list.filter((item) => item.applyFor).map((itm) => itm.id);
    setValue(ids);
  }, [list]);

  const handleCancel = () => {
    setVisible(true);
    onCancel && onCancel();
  };

  const options = React.useMemo(
    () =>
      list.map((item) => ({
        label: (
          <div className="check-item">
            <Tooltip placement="topLeft" title={item.equityDesc} overlayClassName="table-item-tip">
              {item.equityCode}
            </Tooltip>
          </div>
        ),
        value: item.id,
        disabled: item.applyFor,
      })),
    [list],
  );
  const handleChange = (newValue) => {
    setValue(newValue);
  };
  const handleConfirm = async () => {
    if (!value.length) {
      message.warn('请选择要申请的会员权益');
      return;
    }
    setConfirmLoading(true);
    let data = list
      .filter((item) => !item.applyFor && value.includes(item.id))
      .map((itm) => {
        return {
          equityId: itm.id,
          equityCode: itm.equityCode,
        };
      });
    const res = await network({
      url: api.profile.applyEquity,
      method: 'post',
      data,
    });
    setConfirmLoading(false);
    if (res.success) {
      let result = generatorObject(res.data);
      if (!result.success) {
        message.error(result.message);
        return;
      }
      message.success('申请成功');
      onConfirm && onConfirm();
    } else {
      message.error(res.message);
    }
  };

  return (
    <>
      <Modal
        title="可申请的权益"
        visible={visible}
        width={500}
        onCancel={() => handleCancel()}
        footer={[
          <Button type="dafault" onClick={handleCancel}>
            取消
          </Button>,
          <Button type="primary" onClick={handleConfirm} loading={confirmLoading}>
            确认
          </Button>,
        ]}
      >
        <div className="qeuity-content">
          <Checkbox.Group options={options} value={value} onChange={handleChange} />
        </div>
      </Modal>
    </>
  );
};
